import { Dialog, DialogPanel } from '@headlessui/react'
import { UserIcon } from '@heroicons/react/24/outline'
import XMarkIcon from '@heroicons/react/24/outline/XMarkIcon'
import React, { Dispatch, SetStateAction } from 'react'
import { LinkLogo } from './LinkLogo'
import { MenuLink } from './MenuLink'
import { MobileMenuButton } from './MobileMenuButton/MobileMenuButton'
import { LinkButton } from './linkButton'
import { contextMenu } from './utils'

interface MobileMenuProps {
  menuItems: typeof contextMenu[0]['links']
  getAccountLink: string
  openNav: boolean
  setOpenNav: Dispatch<SetStateAction<boolean>>
  isCommercialLanding: boolean
}

export const MobileMenu = ({
  menuItems,
  getAccountLink,
  openNav,
  setOpenNav,
  isCommercialLanding,
}: MobileMenuProps) => (
  <div className='flex flex-row flex-1 justify-between items-center md:hidden px-4 py-1.5'>
    <LinkLogo />
    <MobileMenuButton
      openNav={openNav}
      setOpenNav={setOpenNav}
    />
    <Dialog open={openNav} onClose={setOpenNav} className="lg:hidden">
      <div className="fixed inset-0 z-50" />
      <DialogPanel className="overflow-y-auto fixed inset-y-0 right-0 z-50 p-6 w-full bg-white sm:max-w-sm sm:ring-1 sm:ring-night/10">
        <div className="flex justify-between items-center">
          <LinkLogo />
          <button
            type="button"
            onClick={() => setOpenNav(false)}
            className="-m-2.5 rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon aria-hidden="true" className="size-6" />
          </button>
        </div>

        <div className="flow-root mt-6">
          <div className="-my-6 divide-y divide-gray-500/10">
            <div className="py-6 space-y-2">
              <ul className='space-y-3.5 py-4 pl-0.5'>
                {menuItems.map(({
                  title,
                  link,
                  isExternal = false,
                  isFolder = false,
                  links = [],
                }) => {
                  if (isFolder && links && links.length > 0) {
                    return links.map(({
                      title: childTitle,
                      link: childLink,
                      isExternal: childIsExternal,
                    }) => (
                      <li key={childTitle}>
                        <MenuLink
                          href={childLink || ''}
                          className="block font-semibold rounded-lg text-night text-sm/7 hover:bg-gray-50"
                          isExternal={childIsExternal}
                          label={childTitle}
                          title={childTitle}
                        />
                      </li>
                    ))
                  }
                  return (
                    <li key={title}>
                      <MenuLink
                        href={link || ''}
                        className="block font-semibold rounded-lg text-night text-sm/7 hover:bg-gray-50"
                        isExternal={isExternal}
                        label={title}
                        title={title}
                      />
                    </li>
                  )
                })}
              </ul>
            </div>

            <div className='flex flex-col gap-y-4 justify-center items-center py-6'>
              <a
                href={getAccountLink}
                className='flex gap-x-2 items-center px-4 py-2 text-white rounded-md bg-primary'
              >
                <UserIcon className="size-5" />
                <span>Mon compte {isCommercialLanding ? 'employeur' : 'candidat'}</span>
              </a>

              <LinkButton
                title={isCommercialLanding ? 'Accéder à l\'espace candidat' : 'Accéder à l\'espace employeur'}
                href={isCommercialLanding ? '/offres' : '/je-suis-un-cabinet'}
                label={isCommercialLanding ? 'Espace candidat' : 'Espace employeur'}
                color='white'
                size="medium"
              />
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  </div>
)
